"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const inversify_1 = require("inversify");
const await_1 = require("./await");
const common_1 = require("./common");
const store_1 = require("./store");
function isClassProviderConfigEntry(entry) {
    return (Object.prototype.hasOwnProperty.call(entry, 'provide') &&
        Object.prototype.hasOwnProperty.call(entry, 'useClass'));
}
function isValueProviderConfigEntry(entry) {
    return (Object.prototype.hasOwnProperty.call(entry, 'provide') &&
        Object.prototype.hasOwnProperty.call(entry, 'useValue'));
}
const Provider = ({ singletons, instances, fallback, children }) => {
    const parentContainer = (0, react_1.useContext)(common_1.ContainerContext);
    const [container, setContainer] = (0, react_1.useState)();
    const [promises, setPromises] = (0, react_1.useState)();
    (0, react_1.useLayoutEffect)(() => {
        const container = new inversify_1.Container();
        container.parent = parentContainer;
        const bind = (entry) => {
            if (isClassProviderConfigEntry(entry)) {
                return container.bind(entry.provide).to(entry.useClass);
            }
            if (isValueProviderConfigEntry(entry)) {
                // using toDynamicValue to return BindingInSyntax
                return container.bind(entry.provide).toDynamicValue(() => entry.useValue);
            }
            return container.bind(entry).to(entry);
        };
        singletons === null || singletons === void 0 ? void 0 : singletons.map(bind).forEach(binding => {
            binding.inSingletonScope();
        });
        instances === null || instances === void 0 ? void 0 : instances.forEach(bind);
        const storeInstances = [...(singletons !== null && singletons !== void 0 ? singletons : []), ...(instances !== null && instances !== void 0 ? instances : [])]
            .map(entry => {
            if (isValueProviderConfigEntry(entry)) {
                return undefined;
            }
            const { provide, useClass } = isClassProviderConfigEntry(entry)
                ? entry
                : { provide: entry, useClass: entry };
            if ((0, store_1.isStore)(useClass)) {
                return container.get(provide);
            }
            return undefined;
        })
            .filter(Boolean);
        const promises = [];
        for (const instance of storeInstances) {
            if (instance.initialize) {
                promises.push(instance.initialize());
            }
        }
        setContainer(container);
        setPromises(promises);
        return () => {
            const unbind = (entry) => {
                if (isClassProviderConfigEntry(entry) || isValueProviderConfigEntry(entry)) {
                    return container.unbind(entry.provide);
                }
                return container.unbind(entry);
            };
            singletons === null || singletons === void 0 ? void 0 : singletons.forEach(unbind);
            instances === null || instances === void 0 ? void 0 : instances.forEach(unbind);
            for (const instance of storeInstances) {
                if (instance.dispose) {
                    instance.dispose();
                }
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (!container) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(common_1.ContainerContext.Provider, Object.assign({ value: container }, { children: (promises === null || promises === void 0 ? void 0 : promises.length) ? ((0, jsx_runtime_1.jsx)(await_1.Await, Object.assign({ promises: promises, fallback: fallback }, { children: children }), void 0)) : (children) }), void 0));
};
exports.Provider = Provider;
//# sourceMappingURL=provider.js.map